import Transform from '@ember-data/serializer/transform';

// eslint-disable-next-line ember/no-classic-classes
export default Transform.extend({
  deserialize(serialized) {
    return serialized;
  },
  serialize(deserialized) {
    return deserialized || null;
  }
});